import { httpGet, httpPost, httpPatchMerge, httpDelete } from './../http'
import type { TEntityId } from '~/types/models'
import type { IIndustry, IIndustryOverview } from '~/types/industry/models'

const apiEntityPath = '/api/industries'

export async function getIndustries() {
  const callingMn = getIndustries.name
  const apiPath = `${apiEntityPath}`
  return httpGet<IIndustry[]>({ callingMn, apiPath })
}

export async function getIndustryOverview(id: string) {
  const callingMn = getIndustryOverview.name
  const apiPath = `${apiEntityPath}/${id}/overview`
  return httpGet<IIndustryOverview>({ callingMn, apiPath })
}

export async function createIndustry(entity: IIndustry) {
  const callingMn = createIndustry.name
  const apiPath = apiEntityPath
  return httpPost<IIndustry>({ callingMn, apiPath, entity })
}

export async function updateIndustry(
  entityData: Partial<IIndustry>,
  id: TEntityId
) {
  const callingMn = updateIndustry.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIndustry = Partial<IIndustry>
  return httpPatchMerge<TPartialIndustry>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteIndustry(entityData: IIndustry) {
  const callingMn = deleteIndustry.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
